import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuxiliaresModule } from '../../auxiliares/auxiliares.module';
import { ListarCategoriasComponent } from './listar-categorias/listar-categorias.component';
import { CategoriasRoutingModule } from './categorias.routing.module';
import { CrearEditarCategoriasComponent } from './crear-editar-categorias/crear-editar-categorias.component';
import { CategoriaEditorSharedModule } from '../clientes/categoria-editor/categoria-editor-shared.module';
import { ReemplazoCategoriaSharedModule } from './reemplazo-categoria-dialog/reemplazo-categoria-shared.module';

@NgModule({
  declarations: [
    ListarCategoriasComponent,
    CrearEditarCategoriasComponent,
  ],
  imports: [
    CommonModule,
    AuxiliaresModule,
    CategoriasRoutingModule,
    CategoriaEditorSharedModule,
    ReemplazoCategoriaSharedModule,
  ]
})
export class CategoriasModule { }
